import {getBaseUrl} from './utils';
import {FooterConfig, GetConfigParams} from '../shared';
import getArhiConfig from './arhi';

const PHONE_NUMBER = '1300 853 530';
const CORPORATE_PHONE_NUMBER = null;
const ABSOLUTE_BASEURL = 'https://www.nib.com.au';

const getProvidersConfig = (config: GetConfigParams): FooterConfig => {
  const baseUrl = getBaseUrl(config, ABSOLUTE_BASEURL);
  const arhiConfig = getArhiConfig(config);
  return {
    ...arhiConfig,
    id: 'footer-providers',
    columns: [],
    contact: {
      ...arhiConfig.contact,
      phoneNumber: PHONE_NUMBER,
      corporatePhoneNumber: CORPORATE_PHONE_NUMBER,
      contactUrl: 'tel:1300853530'
    },
    smallFooterConfig: {
      ...arhiConfig.smallFooterConfig,
      id: 'small-footer-providers',
      phoneNumber: PHONE_NUMBER,
      corporatePhoneNumber: CORPORATE_PHONE_NUMBER
    }
  };
};

export default getProvidersConfig;
